export const FETCHING_VEHICLE_CERTIFICATION = '@@toyota/FETCHING_VEHICLE_CERTIFICATION';
export const FETCHED_VEHICLE_CERTIFICATION = '@@toyota/FETCHED_VEHICLE_CERTIFICATION';
export const FETCHED_VEHICLE_CERTIFICATION_FAILED = '@@toyota/FETCHED_VEHICLE_CERTIFICATION_FAILED';

export const CLEAR_VEHICLE_CERTIFICATION = '@@toyota/CLEAR_VEHICLE_CERTIFICATION';
export const CLEAR_IMAGES_VEHICLE_CERTIFICATION = '@@toyota/CLEAR_IMAGES_VEHICLE_CERTIFICATION';
export const CLEAR_PDF_CERTIFICATION = '@@toyota/CLEAR_PDF_CERTIFICATION';

export const ADDING_VEHICLE_CERTIFICATION = '@@toyota/ADDING_VEHICLE_CERTIFICATION';
export const ADDED_VEHICLE_CERTIFICATION = '@@toyota/ADDED_VEHICLE_CERTIFICATION';
export const ADDED_VEHICLE_CERTIFICATION_FAILED = '@@toyota/ADDED_VEHICLE_CERTIFICATION_FAILED';

// LIST VEHICLE CERTIFICATION
export const FETCHING_LIST_VEHICLE_CERTIFICATION = '@@toyota/FETCHING_LIST_VEHICLE_CERTIFICATION';
export const FETCHED_LIST_VEHICLE_CERTIFICATION = '@@toyota/FETCHED_LIST_VEHICLE_CERTIFICATION';
export const FETCHED_LIST_VEHICLE_CERTIFICATION_FAILED = '@@toyota/FETCHED_LIST_VEHICLE_CERTIFICATION_FAILED';

export const ADDING_IMAGE_VEHICLE_CERTIFICATION = '@@toyota/ADDING_IMAGE_VEHICLE_CERTIFICATION';
export const ADDED_IMAGE_VEHICLE_CERTIFICATION = '@@toyota/ADDED_IMAGE_VEHICLE_CERTIFICATION';
export const ADDED_IMAGE_VEHICLE_CERTIFICATION_FAILED = '@@toyota/ADDED_IMAGE_VEHICLE_CERTIFICATION_FAILED';

export const FETCHING_IMAGE_VEHICLE_CERTIFICATION = '@@toyota/FETCHING_IMAGE_VEHICLE_CERTIFICATION';
export const FETCHED_IMAGE_VEHICLE_CERTIFICATION = '@@toyota/FETCHED_IMAGE_VEHICLE_CERTIFICATION';
export const FETCHED_IMAGE_VEHICLE_CERTIFICATION_FAILED = '@@toyota/FETCHED_IMAGE_VEHICLE_CERTIFICATION_FAILED';

// LIST XLS CERTIFICATE
export const FETCHING_XLSX_CERTIFICATION = '@@toyota/FETCHING_XLSX_CERTIFICATION';
export const FETCHED_XLSX_CERTIFICATION = '@@toyota/FETCHED_XLSX_CERTIFICATION';
export const FETCHED_XLSX_CERTIFICATION_FAILED = '@@toyota/FETCHED_XLSX_CERTIFICATION_FAILED';

export const FETCHING_PDF_CERTIFICATION = '@@toyota/FETCHING_PDF_CERTIFICATION';
export const FETCHED_PDF_CERTIFICATION = '@@toyota/FETCHED_PDF_CERTIFICATION';
export const FETCHED_PDF_CERTIFICATION_FAILED = '@@toyota/FETCHED_PDF_CERTIFICATION_FAILED';


// CERTIFICATE SALE
export const FETCHING_VEHICLE_CERTIFICATION_SALE = '@@toyota/FETCHING_VEHICLE_CERTIFICATION_SALE';
export const FETCHED_VEHICLE_CERTIFICATION_SALE = '@@toyota/FETCHED_VEHICLE_CERTIFICATION_SALE';
export const FETCHED_VEHICLE_CERTIFICATION_SALE_FAILED = '@@toyota/FETCHED_VEHICLE_CERTIFICATION_SALE_FAILED';

export const FETCHING_VEHICLE_CERTIFICATION_BY_ID = '@@toyota/FETCHING_VEHICLE_CERTIFICATION_BY_ID';
export const FETCHED_VEHICLE_CERTIFICATION_BY_ID = '@@toyota/FETCHED_VEHICLE_CERTIFICATION_BY_ID';
export const FETCHED_VEHICLE_CERTIFICATION_BY_ID_FAILED = '@@toyota/FETCHED_VEHICLE_CERTIFICATION_BY_ID_FAILED';


export const ADDING_VEHICLE_CERTIFICATION_SALE = '@@toyota/ADDING_VEHICLE_CERTIFICATION_SALE';
export const ADDED_VEHICLE_CERTIFICATION_SALE = '@@toyota/ADDED_VEHICLE_CERTIFICATION_SALE';
export const ADDED_VEHICLE_CERTIFICATION_SALE_FAILED = '@@toyota/ADDED_VEHICLE_CERTIFICATION_SALE_FAILED';

export const CLEAR_VEHICLE_CERTIFICATION_SALE = '@@toyota/CLEAR_VEHICLE_CERTIFICATION_SALE';


// CERTIFICATE OWNER
export const FETCHING_VEHICLE_CERTIFICATE_OWNER = '@@toyota/FETCHING_VEHICLE_CERTIFICATE_OWNER';
export const FETCHED_VEHICLE_CERTIFICATE_OWNER = '@@toyota/FETCHED_VEHICLE_CERTIFICATE_OWNER';
export const FETCHED_VEHICLE_CERTIFICATE_OWNER_FAILED = '@@toyota/FETCHED_VEHICLE_CERTIFICATE_OWNER_FAILED';
export const CLEAR_VEHICLE_CERTIFICATION_OWNER = '@@toyota/CLEAR_VEHICLE_CERTIFICATION_OWNER';

// FETCH RECORD SALES
export const FETCHING_VEHICLE_RECORD_SALE = '@@toyota/FETCHING_VEHICLE_RECORD_SALE';
export const FETCHED_VEHICLE_RECORD_SALE = '@@toyota/FETCHED_VEHICLE_RECORD_SALE';
export const FETCHED_VEHICLE_RECORD_SALE_FAILED = '@@toyota/FETCHED_VEHICLE_RECORD_SALE_FAILED';

// FETCH LABEL
export const FETCHING_VEHICLE_CPO_LABEL = '@@toyota/FETCHING_VEHICLE_CPO_LABEL';
export const FETCHED_VEHICLE_CPO_LABEL = '@@toyota/FETCHED_VEHICLE_CPO_LABEL';
export const FETCHED_VEHICLE_CPO_LABEL_FAILED = '@@toyota/FETCHED_VEHICLE_CPO_LABEL_FAILED';
export const CLEAR_VEHICLE_CPO_LABEL = '@@toyota/CLEAR_VEHICLE_CPO_LABEL';
